import { render, staticRenderFns } from "./JsonDataModal.vue?vue&type=template&id=88a9be16&scoped=true&"
import script from "./JsonDataModal.vue?vue&type=script&lang=js&"
export * from "./JsonDataModal.vue?vue&type=script&lang=js&"
import style0 from "./JsonDataModal.vue?vue&type=style&index=0&id=88a9be16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9be16",
  null
  
)

component.options.__file = "JsonDataModal.vue"
export default component.exports